"use client";

export function DossierActions({canExport,downloadUrl}:{canExport:boolean;downloadUrl:string}) {
  return <div className="dossier-actions no-print">
    {canExport?<a className="dossier-download" href={downloadUrl}>Descargar dossier PDF</a>:
      <button type="button" disabled>Fotos neutras pendientes</button>}
    <button type="button" className="secondary" onClick={() => window.history.back()}>Volver al vehículo</button>
  </div>;
}
